import { Box, Text } from "@chakra-ui/react";

export default function RecreateRg() {
  return (
    <Box p={4}>
      <Text>Coming soon.</Text>
    </Box>
  );
}
